import { library } from '@fortawesome/fontawesome-svg-core'; // Core SVG
import { fal } from '@fortawesome/pro-light-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { faPipe, faXmark } from '@fortawesome/pro-thin-svg-icons';
import { faApple, faGooglePlay } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'; // Integration
import type { App } from 'vue';

export default {
  install: (app: App) => {
    // Thin Icons
    library.add(faXmark);
    library.add(faPipe);
    library.add(faApple);
    library.add(faGooglePlay);

    library.add(fal);
    library.add(far);
    library.add(fas);
    app.component('font-awesome-icon', FontAwesomeIcon);
  }
};
